import {
  getFormData,
  resetFormErrors,
  showFormErrors
} from '../../utils/form';
import * as notification from '../../components/notifications';

let updateTeamMemberModal;
let transferOwnershipModal;
let updateTeamMemberForm;
let selectedUpdateAction;
let teamMemberIdForDeletion;

const initPage = () => {
  updateTeamMemberModal = $("#update-team-member-modal");
  transferOwnershipModal =  $('#transfer-ownership-modal');
  updateTeamMemberForm = $("#update-team-member-form");

  $(".edit-team-member").click(showUpdateModal);
  updateSelectedTeamMemberModalData();

  updateTeamMemberModal.submit(function() {
    updateTeamMember();
    return false;
  });

  $(".delete-team-member").click(showDeleteModal);
  $("#delete-team-member-modal .btn-modal-confirm").click(deleteTeamMember);

  $(".transfer-ownership").click(showTransferOwnershipModal);
  transferOwnershipModal.submit(function() {
    transferOwnership();
    return false;
  });
};

const showUpdateModal = async function (event)  {
  event.preventDefault();
  selectedUpdateAction = $(this);

  const teamMemberId = selectedUpdateAction.attr('data-id');
  const teamMemberName = selectedUpdateAction.attr('data-name');
  const teamMemberEmail = selectedUpdateAction.attr('data-email');
  const teamMemberRole = selectedUpdateAction.attr('data-role');

  updateTeamMemberForm.attr("data-id", teamMemberId);
  $('#update_role_for_team_member_name').text(teamMemberName);
  $('#update_role_for_team_member_email').text(`(${teamMemberEmail})`);
  $('.role-help-text', updateTeamMemberForm).addClass('d-none');
  $(`.${teamMemberRole}-help-text`, updateTeamMemberForm).removeClass('d-none');
  $('#update-team-member-form select.custom-field-select').selectpicker('val', teamMemberRole);

  updateTeamMemberModal.modal('show');
};

const updateSelectedTeamMemberModalData = () => {
  $(document).on('click', '#update-team-member-form .jb-custom-select .dropdown-menu li', function () {
    const selectedRole = $('#update-team-member-form select.custom-field-select').selectpicker('val');

    if (!selectedRole) {
      return;
    }

    $('.role-help-text', updateTeamMemberForm).addClass('d-none');
    $(`.${selectedRole}-help-text`, updateTeamMemberForm).removeClass('d-none');
    selectedUpdateAction.attr('data-role', selectedRole);
  });
};

const updateTeamMember = async () => {
  const  updateTeamMemberForm = $("#update-team-member-form");
  const teamMemberId = updateTeamMemberForm.attr('data-id');

  if (!teamMemberId) {
    return;
  }

  try {
    const data = getFormData(updateTeamMemberForm);
    const updateUri = '/api/account/team_members/' + teamMemberId;

    const response = await axios.patch(updateUri, data);
    resetFormErrors(updateTeamMemberForm);
    const selectedRoleText = $('#update-team-member-form select.custom-field-select option:selected').text()

    $(`.team-member-role-${teamMemberId}`).text(selectedRoleText);

    updateTeamMemberModal.modal('hide');
    notification.success(response.data.message);
  } catch (e) {
    showFormErrors(updateTeamMemberForm, e.response);
  }
};

const showDeleteModal = function (event) {
  event.preventDefault();
  teamMemberIdForDeletion = $(this).data('id');
  const teamMemberName = $(this).data('name');

  $(`#modal_delete_team_member_name`).text(teamMemberName);
  $('#delete-team-member-modal').modal('show');
};

const deleteTeamMember = async function (event) {
  try {
    if (!teamMemberIdForDeletion) {
      return;
    }

    const response = await axios.delete(`/api/account/team_members/${teamMemberIdForDeletion}`);

    $('#delete-team-member-modal').modal('hide');

    $(`.team-member-${teamMemberIdForDeletion}`).remove();
    notification.success(response.data.message);

    const teamMemberItems = $('.team-members-container .item-row');

    if (teamMemberItems.length < 2) {
      setTimeout(() => {
        window.location.reload();
      }, 1300)
    }
  } catch (e) {
    if (e.response.data?.message) {
      notification.danger(e.response.data.message);
    }

    $('#delete-team-member-modal').modal('hide');
  }
};

const showTransferOwnershipModal = function (event) {
  event.preventDefault();

  transferOwnershipModal.modal('show');
};

const transferOwnership = async () => {
  const transferOwnershipForm = $("#transfer-ownership-form");

  try {
    const data = getFormData(transferOwnershipForm);
    const transferOwnershipUri = '/api/account/team_members/transfer_ownership';

    const response = await axios.post(transferOwnershipUri, data);
    resetFormErrors(transferOwnershipForm);

    transferOwnershipModal.modal('hide');
    notification.success(response.data.message);

    setTimeout(() => {
      const redirectUrl = transferOwnershipForm.attr('data-success-redirect');
      window.location.replace(redirectUrl);
    }, 3000);
  } catch (e) {
    transferOwnershipModal.modal('hide');
    showFormErrors(transferOwnershipForm, e.response);
  }
};

$(initPage);
